import React from 'react';
import { Users, Clock, Droplets, LayoutDashboard, Lock, PenTool } from 'lucide-react';
import styles from './WhyUs.module.css';
import { useScrollAnimation, useStaggerAnimation } from '../hooks/useScrollAnimation';

const REASONS = [
  {
    icon: Users,
    title: 'Human-operated, not bots',
    desc: "Every action on Reddit — every upvote, every comment — is done by a real person using our account network. No scripts, no bots, no automated patterns that Reddit's systems catch instantly.",
  },
  {
    icon: Clock,
    title: 'Aged accounts only',
    desc: 'All accounts in our network are at least 6 months old with established karma and posting history across multiple subreddits. Fresh accounts get banned. Ours don\'t.',
  },
  {
    icon: Droplets,
    title: 'Drip delivery — always',
    desc: "We never dump 500 upvotes on a post in one hour. Every order is paced to mimic real organic engagement — so your post climbs naturally and holds its position.",
  },
  {
    icon: LayoutDashboard,
    title: 'Full transparency via dashboard',
    desc: "See exactly what's being delivered — upvote counts, comment placements, delivery pace, karma milestones. No guessing. No 'trust us.' Every action is logged.",
  },
  {
    icon: Lock,
    title: 'We never need your password',
    desc: "We work from your post URL and brief alone. Your Reddit credentials, account security, and brand reputation are never put at risk. You're always in control.",
  },
  {
    icon: PenTool,
    title: 'Comments written to blend in',
    desc: "We write every comment to match the tone, vocabulary, and culture of the target subreddit. Generic filler gets flagged and ignored. Ours read like a real user typed them.",
  },
];

export default function WhyUs() {
  const headRef = useScrollAnimation();
  const gridRef = useStaggerAnimation();

  return (
    <section className={styles.section} id="why">
      <div className="container">
        <div className={`fade-up`} ref={headRef} style={{ marginBottom: 48 }}>
          <div className="section-label">Why GrowthBurrow</div>
          <h2 className="section-title">
            Built different
            <br />
            from the rest.
          </h2>
        </div>
        <div className={styles.grid} ref={gridRef}>
          {REASONS.map((r) => (
            <div key={r.title} className={`${styles.item} stagger-child`}>
              <div className={styles.icon}>
                <r.icon size={22} className="text-accent" />
              </div>
              <div className={styles.text}>
                <h4 className={styles.itemTitle}>{r.title}</h4>
                <p className={styles.itemDesc}>{r.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
